function mpsbSmartSearchQuery(value) {
  const query = String(value || '').trim();
  return window.MPSBSmartSearch?.build(query) || query;
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      const displayQuery = new URL(location.href).searchParams.get('mpsb_q');
      if (displayQuery && this.input.id === 'Search-In-Template') this.input.value = displayQuery.slice(0, 160);
      this.input.form.addEventListener('submit', this.resolveSearchSubmit.bind(this));
      this.input.form.addEventListener('formdata', (event) => {
        const query = event.formData.get('q');
        if (typeof query === 'string') {
          event.formData.set('q', this.resolvedFor === query ? this.resolvedQuery : mpsbSmartSearchQuery(query));
          event.formData.set('mpsb_q', query.slice(0, 160));
        }
      });
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.resetButton && this.input) {
      this.toggleResetButton();
    }
  }

  async resolveSearchSubmit(event) {
    if (!window.MPSBSmartSearch?.load) return;
    const value = this.input.value.trim();
    if (!value || this.querySelector('[aria-selected="true"] a')) return;
    event.preventDefault();
    this.submitController?.abort();
    this.submitController = new AbortController();
    const controller = this.submitController;
    this.input.setAttribute('aria-busy', 'true');
    try {
      const result = await window.MPSBSmartSearch.load(value, { signal: controller.signal });
      if (controller.signal.aborted || this.input.value.trim() !== value) return;
      this.resolvedFor = this.input.value;
      this.resolvedQuery = result.query;
      this.navigateSearch(value, result.query);
    } catch (error) {
      if (controller.signal.aborted || this.input.value.trim() !== value) return;
      this.navigateSearch(value, mpsbSmartSearchQuery(value));
    } finally {
      if (this.submitController === controller) this.input.removeAttribute('aria-busy');
    }
  }

  navigateSearch(value, query) {
    const url = new URL(this.input.form.action, location.origin);
    new FormData(this.input.form).forEach((entry, key) => url.searchParams.set(key, entry));
    url.searchParams.set('q', query);
    url.searchParams.set('mpsb_q', value.slice(0, 160));
    if (window.MPSBSmartSearch.plan(value).exact) {
      url.searchParams.delete('options[prefix]');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[fields]', 'title,product_type,variants.title,vendor,variants.sku,variants.barcode,body,tag');
      url.searchParams.set('options[unavailable_products]', 'show');
    }
    location.assign(url.href);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.resetButton && this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
